import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { clearAdminSession, isAdminUser } from "../utils/adminAuth";

const API_BASE_URL = "https://backend-qybe.onrender.com";

const AdminLogin = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const loginHint = useMemo(() => "Acces reserve aux administrateurs", []);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");
    setIsSubmitting(true);

    try {
      const response = await axios.post(`${API_BASE_URL}/api/auth/login`, form);
      const { user, accessToken, refreshToken } = response.data;

      if (!isAdminUser(user)) {
        clearAdminSession();
        setError("Ce compte n'a pas les droits administrateur.");
        return;
      }

      if (!accessToken) {
        clearAdminSession();
        setError("Connexion admin invalide: token manquant dans la reponse back.");
        return;
      }

      localStorage.setItem("adminToken", accessToken);
      localStorage.setItem("adminRefreshToken", refreshToken || "");
      localStorage.setItem("adminUser", JSON.stringify(user));

      navigate("/admin/dashboard", { replace: true });
    } catch (requestError) {
      setError(
        requestError?.response?.data?.msg ||
          "Connexion admin impossible. Verifiez vos identifiants."
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-950 text-slate-100 flex items-center justify-center p-6">
      <div className="w-full max-w-md bg-slate-900 border border-cyan-500/40 rounded-2xl shadow-[0_0_60px_rgba(6,182,212,0.25)] p-8">
        <p className="text-cyan-300 uppercase tracking-[0.25em] text-xs mb-3">Back Office</p>
        <h1 className="text-3xl font-black mb-2">Connexion Admin</h1>
        <p className="text-slate-400 text-sm mb-6">{loginHint}</p>

        <form onSubmit={handleSubmit} autoComplete="on" className="space-y-4">
          <input
            type="email"
            name="email"
            value={form.email}
            onChange={handleChange}
            placeholder="Email administrateur"
            autoComplete="username"
            required
            className="w-full bg-slate-800 border border-slate-700 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-cyan-400"
          />

          <div className="relative">
            <input
              type={showPassword ? "text" : "password"}
              name="password"
              value={form.password}
              onChange={handleChange}
              placeholder="Mot de passe"
              autoComplete="current-password"
              required
              className="w-full bg-slate-800 border border-slate-700 rounded-lg px-4 py-3 pr-12 focus:outline-none focus:ring-2 focus:ring-cyan-400"
            />
            <button
              type="button"
              onClick={() => setShowPassword((prev) => !prev)}
              className="absolute right-3 top-1/2 -translate-y-1/2 text-sm text-cyan-300 hover:text-cyan-200"
            >
              {showPassword ? "Masquer" : "Afficher"}
            </button>
          </div>

          {error && (
            <div className="rounded-lg bg-rose-500/10 border border-rose-500/40 text-rose-300 px-3 py-2 text-sm">
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={isSubmitting}
            className="w-full bg-cyan-400 text-slate-950 font-bold rounded-lg py-3 hover:bg-cyan-300 transition disabled:opacity-60"
          >
            {isSubmitting ? "Connexion..." : "Entrer dans le BO"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
